exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".steps-box[data-v-54d57c4f]{display:flex;justify-content:center}", ""]);

// exports
